<!--
@Author: Yu XiuJie
@Desc: 底部悬浮框
@Date: 2023-09-04 11时
-->
<template>
  <div class="pc-suspension-dialog" v-show="isDialog">
    <div
      class="suspension-info"
      :style="{
        left: -scrollLeft + 'px'
      }"
    >
      <img class="icon-close" src="../../static/pc/icon_home_closure.png" alt="" @click="closeBtn">
    </div>

    <div class="info-box" :style="{ left: -scrollLeft + 51 + 'px' }">
      <span class="info-tip"
        >填写您的联系信息，我们将安排专业的业务顾问为您提供更周全的服务~</span
      >
      <el-form
        class="suspension-form"
        :rules="formRules"
        ref="paramAppointment"
        :model="paramAppointment"
      >
        <el-form-item class="suspension-form-line" prop="name">
          <el-input
            type="text"
            v-model="paramAppointment.name"
            placeholder="请填写您的真实姓名"
          ></el-input>
        </el-form-item>
        <el-form-item class="suspension-form-line" prop="phone">
          <el-input
            type="text"
            v-model="paramAppointment.phone"
            placeholder="请填写您的联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item class="suspension-form-line" prop="companyName">
          <el-input
            type="text"
            v-model="paramAppointment.companyName"
            placeholder="请填写您的公司全称"
          ></el-input>
        </el-form-item>
        <el-form-item class="suspension-form-line" prop="provinceCity">
          <el-cascader
            v-model="paramAppointment.provinceCity"
            :options="optionsProvinceOrCity"
            placeholder="请选择公司所在位置"
            @change="handleChange"
            @expand-change="expandChange"
            ref="cascader"
          ></el-cascader>
        </el-form-item>
        <div class="suspension-form-btn" @click="xhrImmediatelySub()">
          立即预约
        </div>
      </el-form>
    </div>
  </div>
</template>

<script type="text/javascript">
import { MessageBox } from "element-ui";
import { postMakeAppoint, postFindProvinceOrCity } from "../service/apis";
import { HTTP_CODE } from "../service/axios_constants";
import { checkNull} from "../filters/filters";

export default {
  name: "pc-suspension-dialog",
  props: {
    source: {
      type: String,
      defalut: ''
    } // 子组件传过来的
  },

  data() {
    return {
      scrollLeft: 0,
      //校验
      formRules: {
        name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: ["blur", "change"]
          }
        ],
        phone: [{ required: true, message: "电话不能为空", trigger: "blur" }],
        companyName: [
          { required: true, message: "公司不能为空", trigger: "blur" }
        ],
        provinceCity: [
          { required: true, message: "公司所在城市不能为空", trigger: "blur" }
        ]
      },

      optionsProvinceOrCity: [], //公司所在城市区选择
      optionsProvinceOrCityTemp: [],

      paramAppointment: {
        name: "",
        phone: "",
        companyName: "",
        source: "",
        bdVid: "",
        province: "",
        city: "",
        provinceCity: ""
      },

      clickDisabled: false, // 禁止重复点击预约
      isDisplay: false,
      isDialog: true,
    };
  },

  inject: ["reload"], // 引入刷新方法

  components: {},

  created() {
    this.isIE();
    this.paramAppointment.bdVid = this.$route.query.bd_vid;
    this.isDialog = true;
    this.xhrPostFindProvinceOrCity();
    
  },

  mounted() {},

  methods: {
    handleChange(value) {
      // console.log(this.$refs['cascader'].getCheckedNodes()[0].pathLabels,'yuyu');
      this.paramAppointment.province = this.$refs[
        "cascader"
      ].getCheckedNodes()[0].pathLabels[0];
      this.paramAppointment.city = this.$refs[
        "cascader"
      ].getCheckedNodes()[0].pathLabels[1];
    },

    expandChange(value) {
      this.xhrPostFindProvinceOrCity(value[0]);
    },

    // xhr----查询省市接口
    xhrPostFindProvinceOrCity(value) {
      let paramQuery = {
        provinceId: value
      };
      postFindProvinceOrCity(paramQuery).then(res => {
        if (res.statusCode === HTTP_CODE.suc) {
          if (checkNull(paramQuery.provinceId)) {
            this.optionsProvinceOrCityTemp = res.data;
            for (let type of this.optionsProvinceOrCityTemp) {
              type.value = type.code;
              type.label = type.name;
              type.children = [];
            }
          } else {
            for (let item of this.optionsProvinceOrCityTemp) {
              if (item.code == value) {
                item.children = res.data;
                for (let val of item.children) {
                  val.value = val.code;
                  val.label = val.name;
                }
              }
            }
          }
          this.optionsProvinceOrCity = JSON.parse(
            JSON.stringify(this.optionsProvinceOrCityTemp)
          );
        }
      });
    },

    //xhr--立即预约
    xhrImmediatelySub() {
      if (this.clickDisabled) {
        return;
      }
      this.$refs["paramAppointment"].validate(valid => {
        if (valid) {
          this.clickDisabled = true;
          this.paramAppointment.source = this.source;

          postMakeAppoint(this.paramAppointment).then(res => {
            this.clickDisabled = false;
            if (res.statusCode === HTTP_CODE.suc) {
              this.isDisplay = false;
              this.$refs["paramAppointment"].resetFields();
              this.paramAppointment.provinceCity = ''
              MessageBox("预约成功！", "提示", {
                confirmButtonText: "确定",
                showCancelButton: false,
                confirmButtonClass: "btnFullColor"
              });
            } 
          });
        }
      });
    },

    //滚动条滑动的距离
    handelScroll() {
      // 解决ie兼容性
      if (!checkNull(this.scrollLeft)) {
        this.scrollLeft =
          window.pageXOffset ||
          document.body.scrollLeft ||
          document.scrollingElement.scrollLeft ||
          document.documentElement.scrollLeft;
      }
    },

    //ie浏览器的环境
    isIE() {
      //ie?
      if (!window.ActiveXObject || "ActiveXObject" in window) {
        window.addEventListener("scroll", this.handelScroll, true);
      }
    },

    closeBtn(){
      this.isDialog = !this.isDialog
    }
  }
};
</script>
<style>
.pc-suspension-dialog .el-input__inner {
  width: 240px;
  height: 50px;
  background: #ffffff;
  border-radius: 28px;
}
.pc-suspension-dialog .el-form-item__error {
  text-indent: 20px;
}
</style>

<style lang="scss" scoped>
.pc-suspension-dialog {
  position: fixed;
  width: 100%;
  height: 160px;
   /*全面屏适配*/
  height:calc(160px + constant(safe-area-inset-bottom));
  height:calc(160px + env(safe-area-inset-bottom));
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(218, 234, 253, 0.8);
  backdrop-filter: blur(10px);
  box-sizing: border-box;
  padding-bottom:1px;
 

  .suspension-info {
    position: fixed;
    width: 100%;
    min-width: 1300px;
    height: 160px;
    left: 0;
    bottom: 0;
    background-image: url("../../static/pc/img_bg_tanchuang_l.png"),
      url("../../static/pc/img_bg_tanchuang_r.png");
    background-position: left, right;
    background-clip: border-box;
    background-repeat: no-repeat, no-repeat;
    background-size: 675px 160px, 770px 160px;
    // background-color: red;
  }

  .icon-close{
    width: 26px;
    height: 26px;
    position: absolute;
    right: 61px;
    top: 26px;
  }

  .info-box {
    position: fixed;
    width: 100%;
    left: 51px;
    right: 51px;
    bottom: 0;
    z-index: 999;
    width: 1198px;
    height: 91px;
    margin: 35px auto;
    text-align: left;

    .info-tip {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2a2c33;
      line-height: 28px;
    }

    .suspension-form {
      display: flex;
      margin-top: 13px;

      .suspension-form-line {
        width: 240px;
        height: 50px;
        margin-right: 10px;
      }

      .suspension-form-btn {
        width: 197px;
        height: 50px;
        margin-left: 10px;
        background: linear-gradient(108deg, #58c6ff 0%, #57a6ff 100%);
        border-radius: 28px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 50px;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pcSuspensionDialog.vue